module.exports = __webpack_public_path__ + "fonts/49f9513a2f2c6eb3b8e808448ab122b7.txt";